import React, { useContext } from 'react'

export enum RequiredOrOptional {
  Optional = 'Optional',
  Required = 'Required',
}

interface FormContextValue {
  formId: string
  requiredOrOptionalIndicator?: RequiredOrOptional
}

const formContext = React.createContext<FormContextValue | undefined>(undefined)

export const FormProvider = formContext.Provider

export const useFormContext = (): Partial<FormContextValue> =>
  useContext(formContext) ?? ({} as Partial<FormContextValue>)
